import { asyncModule } from '../utils/async-module';
import * as JSModules from '../components/modules';
import { asyncPreactWidget } from '../utils/async-preact-widget';
import * as preactWidgets from '../preact/widgets';
import {
  hasLmpTab,
  isHoroscopeAffinity,
  isHoroscopeDetailSignPage,
  isHoroscopeHomepage,
  isMeaningNamePage,
} from '../utils/aem-utils';
import { commonActions } from '../global-store/subjects/common';
import { embedsSelectors } from '../components/embeds/vendors';
import { landToElement } from '../utils/land-to-element';
import { analyticsFrom } from '../utils/analytics-from';

export const asyncAdvTopBottom = () => {
  const $advTopDataNodes = document.querySelectorAll('.js-adv-container-top[data-state="to-insert"]');
  const $advBottomDataNodes = document.querySelectorAll('.js-adv-container-bottom[data-state="to-insert"]');
  if ($advTopDataNodes.length || $advBottomDataNodes.length) {
    const { start, getInit, error } = asyncModule(JSModules.advTopBottomModule);
    start();
    import('../components/adv/adv-top-bottom').then(getInit({ $advTopDataNodes, $advBottomDataNodes })).catch(error);
  }
};

export const asyncAdvArticle = () => {
  const $advTopDataNode = document.querySelector('#dataAdvTop');
  const $advInReadVideoDataNode = document.querySelector('#dataAdvVideoInRead');
  const $advInArticleDataNode = document.querySelector('#dataAdvInArticle');
  const { shouldInit, start, getInit, error } = asyncModule(JSModules.advArticleModule);
  if (shouldInit({ $advTopDataNode, $advInReadVideoDataNode, $advInArticleDataNode })) {
    start();
    import('../components/adv/adv-article')
      .then(getInit({ $advTopDataNode, $advInReadVideoDataNode, $advInArticleDataNode }))
      .catch(error);
  }
};

export const asyncAdvSkin = () => {
  const $advSkinDataNode = document.querySelector('#advContainer_skin');
  const { shouldInit, start, getInit, error } = asyncModule(JSModules.advSkinModule);
  if ($advSkinDataNode && shouldInit()) {
    start();
    import('../components/adv/adv-skin').then(getInit($advSkinDataNode)).catch(error);
  }
};

export const asyncAdvIntro = () => {
  const $advIntroDataNode = document.querySelector('#dataAdvIntro');
  const { shouldInit, start, getInit, error } = asyncModule(JSModules.advIntroModule);
  if ($advIntroDataNode && shouldInit()) {
    start();
    import('../components/adv/adv-intro').then(getInit($advIntroDataNode)).catch(error);
  }
};

export const asyncParselyRender = () => {
  const $element = document.querySelector('#parselyTopNews');
  if ($element) {
    const { start, getInit, error } = asyncModule(JSModules.parselyRenderModule);
    start();
    import('../components/templating/parsely-render').then(getInit()).catch(error);
  }
};

export const asyncParselyRenderRailMostViewed = () => {
  const $element = document.querySelector('#parselyTopVideos');
  if ($element) {
    const { start, getInit, error } = asyncModule(JSModules.parselyRenderRailMostViewedModule);
    start();
    import('../components/templating/parsely-render-rail-most-viewed').then(getInit($element)).catch(error);
  }
};

export const asyncAnalyticsFrom = () => {
  const analyticsFromValue = analyticsFrom.get();
  if (analyticsFromValue) {
    const { start, getInit, error } = asyncModule(JSModules.analyticsFromModule);
    start();
    import('../components/analytics-from/analytics-from').then(getInit(analyticsFromValue)).catch(error);
    analyticsFrom.clean();
  }
};

export const asyncAudioTagTracking = () => {
  const $element = document.querySelector('.s-audio-tag');
  if ($element) {
    const { start, getInit, error } = asyncModule(JSModules.audioTagsTrackingModule);
    start();
    import('../components/audio-tag/audio-tag-tracking').then(getInit($element)).catch(error);
  }
};

export const asyncAuth = () => {
  const { start, getInit, error } = asyncModule(JSModules.authModule);
  start();
  import('../components/auth/auth').then(getInit()).catch(error);
};

export const asyncLoginOnGlobalNav = () => {
  const { isOnPage, start, hydrate, error } = asyncPreactWidget(preactWidgets.loginOnGlobalNav);
  if (isOnPage()) {
    start();
    import(`../preact/widgets/login-on-global-nav`).then(hydrate).catch(error);
  }
};

export const asyncUserPreferences = () => {
  const { isOnPage, start, hydrate, error } = asyncPreactWidget(preactWidgets.userPreferences);
  if (isOnPage()) {
    start();
    import(`../preact/widgets/user-preferences`).then(hydrate).catch(error);
  }
};

export const asyncPaywall = () => {
  const $element = document.querySelector('.j-paywall');
  if ($element) {
    const { start, getInit, error } = asyncModule(JSModules.paywallModule);
    start();
    import('../components/paywall/paywall').then(getInit($element)).catch(error);
  }
};

export const asyncPremiumPricingTable = () => {
  const $element = document.querySelector('.j-premium-pricing-table');
  if ($element) {
    const { start, getInit, error } = asyncModule(JSModules.premiumPricingTableModule);
    start();
    import('../components/premium-pricing-table/premium-pricing-table').then(getInit($element)).catch(error);
  }
};

export const asyncOutbrain = () => {
  const $outbrainMain = document.querySelector('.j-outbrain');
  const $outbrainInText = document.querySelector('.j-outbrain-intext');
  if ($outbrainMain || $outbrainInText) {
    const { start, getInit, error } = asyncModule(JSModules.outbrainModule);
    start();
    import('../components/outbrain/outbrain').then(getInit({ $outbrainMain, $outbrainInText })).catch(error);
  }
};

export const asyncTwitterLib = () => {
  const { shouldInit, start, getInit, error } = asyncModule(JSModules.twitterLibModule);
  if (shouldInit()) {
    start();
    import('../components/social-scripts/twitter-lib').then(getInit()).catch(error);
  }
};

export const asyncSkySocialShare = () => {
  const { isOnPage, start, hydrate, error } = asyncPreactWidget(preactWidgets.socialShare);
  if (isOnPage() || hasLmpTab()) {
    start();
    import(`../preact/widgets/social-share`).then(hydrate).catch(error);
  }
};

export const asyncAutoPushNotifications = () => {
  const { isOnPage, start, hydrate, error } = asyncPreactWidget(preactWidgets.autoPushNotifications);
  if (isOnPage()) {
    start();
    import(`../preact/widgets/auto-push-notifications`).then(hydrate).catch(error);
  } else {
    commonActions.setPushNotificationInDialogShow(false);
  }
};

export const asyncEmbeds = () => {
  const isEmbedInPage = Object.values(embedsSelectors)
    .map((embedSelector) => document.querySelector(embedSelector))
    .some((node) => Boolean(node));
  if (isEmbedInPage) {
    const { start, getInit, error } = asyncModule(JSModules.embedsModule);
    start();
    import('../components/embeds/embeds').then(getInit()).catch(error);
  }
};
export const asyncToolbarCalendar = () => {
  const $archiveToolbarNode = document.querySelector('.j-archive-toolbar');
  const $archiveToolbarDataNode = document.querySelector('.j-archive-toolbar-data');
  if ($archiveToolbarNode && $archiveToolbarDataNode) {
    const { start, getInit, error } = asyncModule(JSModules.toolbarCalendarModule);
    start();
    import('../components/calendar/toolbar-calendar')
      .then(getInit({ $archiveToolbarNode, $archiveToolbarDataNode }))
      .catch(error);
  }
};

export const asyncInjectHomepage = () => {
  const { shouldInit, start, getInit, error } = asyncModule(JSModules.injectedHomepageModule);
  if (shouldInit()) {
    start();
    import('../components/injected-homepage/injected-homepage').then(getInit()).catch(error);
  }
};

export const asyncTvCardOnRailChangePosition = () => {
  const $element = document.querySelector('.j-tv-card-rail');
  if ($element) {
    const { start, getInit, error } = asyncModule(JSModules.tvCardRailChangePositionModule);
    start();
    import('../components/templating/tv-card-rail').then(getInit($element)).catch(error);
  }
};

export const asyncTvCardSlim = () => {
  const $element = document.querySelector('.j-tv-card-slim');
  if ($element) {
    const { start, getInit, error } = asyncModule(JSModules.tvCardSlimModule);
    start();
    import('../components/templating/tv-card-slim').then(getInit($element)).catch(error);
  }
};

export const asyncSectionDividerSpecial = () => {
  const $element = document.querySelector('.j-section-divider--special');
  if ($element) {
    const { start, getInit, error } = asyncModule(JSModules.sectionDividerSpecialModule);
    start();
    import('../components/section-divider/section-divider-special').then(getInit($element)).catch(error);
  }
};

export const asyncPrimaryTag = () => {
  const { shouldInit, start, getInit, error } = asyncModule(JSModules.primaryTagModule);
  if (shouldInit()) {
    start();
    import('../components/primary-tag/primary-tag').then(getInit()).catch(error);
  }
};

export const asyncPathbreakerSlider = () => {
  const $element = document.querySelector('.j-pathbreaker');
  if ($element) {
    const { start, getInit, error } = asyncModule(JSModules.pathBreakerModule);
    start();
    import('../components/pathbreaker/pathbreaker').then(getInit()).catch(error);
  }
};

export const asyncSignsAffinity = () => {
  if (isHoroscopeAffinity() || isHoroscopeDetailSignPage()) {
    const { start, getInit, error } = asyncModule(JSModules.affinityCalculatorModule);
    start();
    import('../components/horoscope/affinity').then(getInit()).catch(error);
  } else if (isHoroscopeHomepage()) {
    const { start, getInit, error } = asyncModule(JSModules.favouriteSignModule);
    start();
    import('../components/horoscope/favorite-sign').then(getInit()).catch(error);
  } else if (isMeaningNamePage()) {
    const { start, getInit, error } = asyncModule(JSModules.setFilterByInitialModule);
    start();
    import('../components/horoscope/significato-list-name').then(getInit()).catch(error);
  }
};

// asyncCarouselInline vs asyncVideoPlaylistInline: use same preact container but have different policies to show
export const asyncCarouselInline = () => {
  const { isOnPage, shouldInit, start, hydrate, error } = asyncPreactWidget(preactWidgets.carouselInline);
  if ((isOnPage() && shouldInit()) || hasLmpTab()) {
    start();
    import(`../preact/widgets/carousel-inline`).then(hydrate).catch(error);
  }
};

export const asyncInfiniteScrolling = () => {
  const $element = document.querySelector('.infinite-scrolling');
  if ($element) {
    const { start, getInit, error } = asyncModule(JSModules.infiniteScrollingModule);
    start();
    import('../components/infinite-scroll/infinite-scroll').then(getInit($element)).catch(error);
  }
};

export const asyncCheckFilters = () => {
  const $elements = document.querySelectorAll('.j-filter');
  if ($elements.length) {
    const { start, getInit, error } = asyncModule(JSModules.checkFiltersModule);
    start();
    import('../components/filters/filters-toolbar').then(getInit($elements)).catch(error);
  }
};

export const asyncSlimBannerBottomCTA = () => {
  const { isOnPage, start, hydrate, error } = asyncPreactWidget(preactWidgets.slimBannerBottomCTA);
  if (isOnPage()) {
    start();
    import(`../preact/widgets/slim-banner-bottom-CTA`).then(hydrate).catch(error);
  }
};

export const asyncSlimBannerBottomWPN = () => {
  const { isOnPage, start, hydrate, error } = asyncPreactWidget(preactWidgets.slimBannerBottomWPN);
  if (isOnPage()) {
    start();
    import(`../preact/widgets/slim-banner-bottom-WPN`).then(hydrate).catch(error);
  }
};

export const asyncTextToSpeech = () => {
  const { isOnPage, start, hydrate, error } = asyncPreactWidget(preactWidgets.textToSpeech);
  if (isOnPage() || hasLmpTab()) {
    start();
    import(`../preact/widgets/text-to-speech`).then(hydrate).catch(error);
  }
};

export const asyncGlobalNavigation = () => {
  const $element = document.querySelector('.j-global-nav');
  if ($element) {
    const { start, getInit, error } = asyncModule(JSModules.globalNavModule);
    start();
    import('../components/global-nav/global-nav').then(getInit()).catch(error);
  }
};

export const asyncLocalNavigation = () => {
  const $element = document.querySelector('.j-local-nav');
  if ($element) {
    const { start, getInit, error } = asyncModule(JSModules.localNavModule);
    start();
    import('../components/local-navigation/local-navigation').then(getInit()).catch(error);
  }
};

export const asyncSectionNavigation = () => {
  const $element = document.querySelector('.j-section-nav');
  if ($element) {
    const { start, getInit, error } = asyncModule(JSModules.sectionNavModule);
    start();
    import('../components/local-navigation/section-navigation').then(getInit()).catch(error);
  }
};

export const asyncOtherNewsChecker = () => {
  const $element = document.querySelector('.j-other-news');
  if ($element) {
    const { start, getInit, error } = asyncModule(JSModules.otherNewsCheckerModule);
    start();
    import('../components/other-news/other-news').then(getInit()).catch(error);
  }
};

export const asyncNewsYouCanUse = () => {
  const $element = document.querySelector('.j-news-u-can-use');
  if ($element) {
    const { start, getInit, error } = asyncModule(JSModules.newsYouCanUseModule);
    start();
    import('../components/news-u-can-use/news-u-can-use').then(getInit($element)).catch(error);
  }
};

export const asyncLatestNews = () => {
  const { isOnPage, start, hydrate, error } = asyncPreactWidget(preactWidgets.latestNews);
  if (isOnPage()) {
    start();
    import(`../preact/widgets/latest-news`).then(hydrate).catch(error);
  }
};

export const asyncLatestNewsInfinite = () => {
  const { isOnPage, start, hydrate, error } = asyncPreactWidget(preactWidgets.latestNewsInfinite);
  if (isOnPage()) {
    start();
    import(`../preact/widgets/latest-news-infinite`).then(hydrate).catch(error);
  }
};

export const asyncELStreaming = () => {
  const $element = document.querySelector('.j-modal--europa-league');
  if ($element) {
    const { start, getInit, error } = asyncModule(JSModules.modalEuropaLeagueModule);
    start();
    import('../components/europa-league-streaming/europa-league-streaming').then(getInit($element)).catch(error);
  }
};

export const asyncSectionEuroTvSchedule = () => {
  const $element = document.querySelector('.c-banner-text__content');
  if ($element) {
    const { start, getInit, error } = asyncModule(JSModules.euroTvScheduleModule);
    start();
    import('../components/euro-tv-schedule/euro-tv-schedule').then(getInit()).catch(error);
  }
};

export const asyncScrollToTop = () => {
  const $elements = document.querySelectorAll('.j-scroll-to-top');
  if ($elements.length) {
    const { start, getInit, error } = asyncModule(JSModules.scrollToTopModule);
    start();
    import('../components/scroll-to-top/scroll-to-top').then(getInit($elements)).catch(error);
  }
};

export const asyncReadingProgressBar = () => {
  const $paragraphs = document.querySelectorAll('.j-article-section p');
  const { shouldInit, start, getInit, error } = asyncModule(JSModules.readingProgressBarModule);
  if (shouldInit($paragraphs)) {
    start();
    import('../components/reading-progress-bar/reading-progress-bar').then(getInit()).catch(error);
  }
};

export const asyncPageRefresh = () => {
  const { shouldInit, start, getInit, error } = asyncModule(JSModules.pageRefreshModule);
  if (shouldInit()) {
    start();
    import('../components/page-refresh/page-refresh').then(getInit()).catch(error);
  }
};

export const asyncLandToElement = () => {
  const responsiveOffset = landToElement.get()?.responsiveOffset;
  const elementIdToLand = landToElement.get()?.elementId;
  const fallbackElementClassnameToLand = landToElement.get()?.fallbackElementClassname;
  const tabIdToLand = landToElement.get()?.tabId;
  if (elementIdToLand) {
    const { start, getInit, error } = asyncModule(JSModules.landToElementModule);
    start();
    import('../components/land-to-element/land-to-element')
      .then(getInit({ responsiveOffset, elementIdToLand, fallbackElementClassnameToLand, tabIdToLand }))
      .catch(error);
  }
};

export const asyncTabSwitch = () => {
  const $element = document.querySelector('.j-hp-tabs');
  if ($element) {
    const { start, getInit, error } = asyncModule(JSModules.hpTabSwitchModule);
    start();
    import('../components/homepage-tabs/homepage-tabs').then(getInit($element)).catch(error);
  }
};

export const asyncSetOfCardsInfinite = () => {
  const { isOnPage, start, hydrate, error } = asyncPreactWidget(preactWidgets.setOfCardsInfinite);
  if (isOnPage()) {
    start();
    import(`../preact/widgets/set-of-cards-infinite`).then(hydrate).catch(error);
  }
};

export const asyncHeroEditorialPremiumTopic = () => {
  const { start, getInit, error } = asyncModule(JSModules.heroEditorialPremiumTopicModule);
  const $element = document.querySelector('.j-hero-editorial-premium-topic');
  if ($element) {
    start();
    import('../components/hero-editorial-premium-topic/hero-editorial-premium-topic')
      .then(getInit($element))
      .catch(error);
  }
};

export const asyncInfoPage = () => {
  const { start, getInit, error } = asyncModule(JSModules.infoPageModule);
  const $element = document.querySelector('.j-info-page');
  if ($element) {
    start();
    import('../components/info-page/info-page').then(getInit($element)).catch(error);
  }
};

// asyncVideoPlaylistInline vs asyncCarouselInline: use same preact container but have different policies to show
export const asyncVideoPlaylistInline = () => {
  const { isOnPage, start, hydrate, error } = asyncPreactWidget(preactWidgets.videoPlaylistInline);
  if (isOnPage() || hasLmpTab()) {
    start();
    import(`../preact/widgets/video-playlist-inline`).then(hydrate).catch(error);
  }
};

export const asyncVideoArticle = () => {
  const $videoArticlePage = document.querySelector('.j-video-article-page');
  if ($videoArticlePage) {
    const { start, getInit, error } = asyncModule(JSModules.videoArticlePageModule);
    start();
    import('../components/video-article-page/video-article-page').then(getInit()).catch(error);
  }
};

export const asyncMultipleVideoPlaylist = () => {
  const $multipleVideoPlaylist = document.querySelector('#j-player-with-carousel');
  if ($multipleVideoPlaylist) {
    const { shouldInit, start, getInit, error } = asyncModule(JSModules.multipleVideoPlaylistModule);
    if (shouldInit()) {
      start();
      import('../components/multiple-video-playlist/multiple-video-playlist').then(getInit()).catch(error);
    }
  }
};

export const asyncVideoPlayers = () => {
  const $videoPlayer = document.querySelector('.j-player');
  if ($videoPlayer) {
    const { shouldInit, start, getInit, error } = asyncModule(JSModules.videoPlayerModule);
    if (shouldInit()) {
      start();
      import('../components/video-player/init-players').then(getInit()).catch(error);
    }
  }
};

export const asyncWebviewVideoPlayer = () => {
  const $videoPlayerWebview = document.querySelector('.j-player');
  const { shouldInit, start, getInit, error } = asyncModule(JSModules.webviewVideoPlayerModule);
  if (shouldInit() && $videoPlayerWebview) {
    start();
    import('../components/webview-video-player/webview-video-player').then(getInit()).catch(error);
  }
};
